/** Ein offener Tab kann nach einem Deployment noch alte Seitenbausteine anfordern. */
const KEY = 'aff.chunk-recovery';
const STALE_CHUNK = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk .+ failed|Unable to preload CSS/i;

/**
 * Lädt die Seite genau einmal neu, wenn ein Seitenbaustein eines älteren
 * Deployments fehlt. true = Neuladen ist angestoßen.
 *
 * Gilt für beide Wege, auf denen der Fehler ankommt: Vites Vorladen
 * (vite:preloadError) und der fehlgeschlagene import() einer Seite, der in
 * der Fehlergrenze landet. Vorher fing nur der erste Weg; nach dem Deploy am
 * 14.10.2026 stand deshalb „Diese Seite konnte nicht geladen werden" da.
 */
export function reloadOnceForStaleChunk(message: string): boolean {
  if (!STALE_CHUNK.test(message)) return false;
  try {
    const previous = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as { message: string; at: number } | null;
    // Bei einem echten Netzwerkproblem nicht in einer Neuladeschleife hängen bleiben.
    if (previous?.message === message && Date.now() - previous.at < 60_000) return false;
    sessionStorage.setItem(KEY, JSON.stringify({ message, at: Date.now() }));
  } catch { return false; } // Ohne Speicher lässt sich die einmalige Wiederholung nicht sichern.
  window.location.reload();
  return true;
}

export function installChunkRecovery() {
  const onError = (event: Event) => {
    const error = (event as Event & { payload?: Error }).payload;
    if (reloadOnceForStaleChunk(error?.message ?? '')) event.preventDefault();
  };
  window.addEventListener('vite:preloadError', onError);
  return () => window.removeEventListener('vite:preloadError', onError);
}
